import { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaChevronLeft } from "react-icons/fa";
import SidebarLeft from "../SidebarLeft";

import { FaBars } from "react-icons/fa";

const Header = ({ title }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <Container>
      <Row>
        <Col className="d-flex justify-content-between pt-5">
          <div className="d-flex justify-content-start">
            <Button variant="primary" onClick={handleShow}>
              <FaBars />
            </Button>

            <Button variant="primary" className="mx-2">
              <FaChevronLeft size="1em" className="m-2" />
            </Button>

            <h4 className="pt-2 pl-4">{title}</h4>
          </div>

          <SidebarLeft show={show} handleClose={handleClose} />
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
